var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
export var bubbleBackgroundColor = "#4f5666";
export var SwiftSkill;
(function (SwiftSkill) {
    SwiftSkill["Verbal"] = "Verbal Reasoning";
    SwiftSkill["Numerical"] = "Numerical Reasoning";
    SwiftSkill["Abstract"] = "Abstract Reasoning";
    SwiftSkill["Overall"] = "Overall";
})(SwiftSkill || (SwiftSkill = {}));
export var SavilleSwiftAptitudeSkills = [
    SwiftSkill.Verbal,
    SwiftSkill.Numerical,
    SwiftSkill.Abstract,
    SwiftSkill.Overall,
];
var getSwiftSkillDescription = function (text) {
    return [
        [SwiftSkill.Overall],
        [SwiftSkill.Numerical],
        [SwiftSkill.Abstract],
        [SwiftSkill.Verbal],
    ].reduce(function (current, skill) {
        var _a;
        return (__assign(__assign({}, current), (_a = {}, _a[skill.toString()] = text, _a)));
    }, {});
};
var getHoganDescription = function (text, category) {
    var _a;
    return (_a = {},
        _a[category] = text,
        _a);
};
export var Tab;
(function (Tab) {
    Tab["CBI"] = "cbi";
    Tab["SavilleWave"] = "saville-wave";
    Tab["SavilleSwiftAptitude"] = "saville-swift-aptitude";
    Tab["HoganHPI"] = "hogan-hpi";
    Tab["HoganHDS"] = "hogan-hds";
    Tab["HoganMVPI"] = "hogan-mvpi";
    Tab["ImmersiveAgility"] = "immersive-agility";
    Tab["ImmersiveMeta"] = "immersive-meta";
    Tab["Insights"] = "insights";
    Tab["NoColors"] = "no-colors";
})(Tab || (Tab = {}));
export var getTabName = function (tab) {
    var _a;
    return ((_a = {},
        _a[Tab.CBI] = "Final Assessor Ratings",
        _a[Tab.SavilleWave] = "Saville Wave",
        _a[Tab.SavilleSwiftAptitude] = "Saville Swift Aptitude",
        _a[Tab.HoganHPI] = "Hogan HPI",
        _a[Tab.HoganHDS] = "Hogan HDS",
        _a[Tab.HoganMVPI] = "Hogan MVPI",
        _a[Tab.ImmersiveAgility] = "Immersive Agility",
        _a[Tab.ImmersiveMeta] = "Immersive META",
        _a[Tab.Insights] = "Insights",
        _a[Tab.NoColors] = "No Colors",
        _a)[tab] || tab);
};
export var getRiskLevelDescription = function (level, category) {
    var _a, _b, _c;
    var cohortSet = (_a = Colors[category]) === null || _a === void 0 ? void 0 : _a[level - 1];
    return (_c = (_b = cohortSet === null || cohortSet === void 0 ? void 0 : cohortSet.description) === null || _b === void 0 ? void 0 : _b[category]) !== null && _c !== void 0 ? _c : "";
};
export var PageType = (_a = {},
    _a[Tab.CBI] = true,
    _a[Tab.SavilleWave] = false,
    _a[Tab.SavilleSwiftAptitude] = false,
    _a[Tab.HoganHPI] = false,
    _a[Tab.HoganHDS] = false,
    _a[Tab.HoganMVPI] = false,
    _a[Tab.Insights] = false,
    _a[Tab.NoColors] = false,
    _a[Tab.ImmersiveAgility] = false,
    _a[Tab.ImmersiveMeta] = false,
    _a);
export var AverageBarConfigMap = (_b = {},
    _b[Tab.CBI] = { start: 0, end: 5, scale: 5 },
    _b[Tab.SavilleWave] = { start: 0, end: 10, scale: 5 },
    _b[Tab.SavilleSwiftAptitude] = { start: 0, end: 10, scale: 5 },
    _b[Tab.HoganHPI] = { start: 0, end: 100, scale: 5 },
    _b[Tab.HoganHDS] = { start: 0, end: 100, scale: 5 },
    _b[Tab.HoganMVPI] = { start: 0, end: 100, scale: 5 },
    _b[Tab.Insights] = { start: 1, end: 5, scale: 4 },
    _b[Tab.NoColors] = { start: 0, end: 10, scale: 5 },
    _b[Tab.ImmersiveAgility] = { start: 0, end: 5, scale: 5 },
    _b[Tab.ImmersiveMeta] = { start: 0, end: 5, scale: 5 },
    _b);
export var Colors = (_c = {},
    _c[Tab.CBI] = [
        {
            color: "rgb(from #38dbdb r g b / 30%)",
            low: -Infinity,
            high: 2,
            text: "#1a212e",
            description: {
                Capabilities: "Individual Contributor",
                Potential: "Novice",
            },
            border: "#00b2b2",
        },
        {
            color: "#38dbdb",
            low: 2,
            high: 3,
            text: "#1a212e",
            description: { Capabilities: "Team", Potential: "Developing" },
            border: "#00b2b2",
        },
        {
            color: "#00b2b2",
            low: 3,
            high: 4,
            text: "#1a212e",
            description: {
                Capabilities: "Area / Business Unit",
                Potential: "Proficient",
            },
            border: "#00b2b2",
        },
        {
            color: "#095465",
            low: 4,
            high: 5,
            text: "#ffffff",
            description: { Capabilities: "Organizational", Potential: "Expert" },
            border: "#095465",
        },
        {
            color: "#08314c",
            low: 5,
            high: Infinity,
            text: "#ffffff",
            description: {
                Capabilities: "Extra-Organizational",
                Potential: "World-Class",
            },
            border: "#08314c",
        },
    ],
    _c[Tab.SavilleWave] = [
        {
            color: "rgb(from #197E95 r g b / 1%)",
            low: -Infinity,
            high: 2.5,
            text: "#1a212e",
            description: { Capabilities: "Very Low", Potential: "Very Low" },
            border: "#197E95",
        },
        {
            color: "rgb(from #197E95 r g b / 10%)",
            low: 2.5,
            high: 4.5,
            text: "#1a212e",
            description: { Capabilities: "Low", Potential: "Low" },
            border: "#197E95",
        },
        {
            color: "rgb(from #197E95 r g b / 25%)",
            low: 4.5,
            high: 6.5,
            text: "#1a212e",
            description: { Capabilities: "Average", Potential: "Average" },
            border: "#197E95",
        },
        {
            color: "rgb(from #197E95 r g b / 50%)",
            low: 6.5,
            high: 8.5,
            text: "#1a212e",
            description: { Capabilities: "High", Potential: "High" },
            border: "#197E95",
        },
        {
            color: "#197E95",
            low: 8.5,
            high: Infinity,
            text: "#ffffff",
            description: { Capabilities: "Very High", Potential: "Very High" },
            border: "#197E95",
        },
    ],
    _c[Tab.SavilleSwiftAptitude] = [
        {
            color: "#FFFFFF",
            low: -Infinity,
            high: 2.5,
            text: "#1a212e",
            description: getSwiftSkillDescription("Very Low"),
            border: "#2CDADA",
        },
        {
            color: "rgb(from #2CDADA r g b / 10%)",
            low: 2.5,
            high: 4.5,
            text: "#1a212e",
            description: getSwiftSkillDescription("Low"),
            border: "#2CDADA",
        },
        {
            color: "rgb(from #2CDADA r g b / 25%)",
            low: 4.5,
            high: 6.5,
            text: "#1a212e",
            description: getSwiftSkillDescription("Average"),
            border: "#2CDADA",
        },
        {
            color: "rgb(from #2CDADA r g b / 50%)",
            low: 6.5,
            high: 8.5,
            text: "#1a212e",
            description: getSwiftSkillDescription("High"),
            border: "#2CDADA",
        },
        {
            color: "#2CDADA",
            low: 8.5,
            high: Infinity,
            text: "#1a212e",
            description: getSwiftSkillDescription("Very High"),
            border: "#2CDADA",
        },
    ],
    _c[Tab.Insights] = [
        {
            color: "#FF6C6C",
            low: 0,
            high: 79,
            border: "#AE4D3D",
            description: { all: "Act" },
        },
        {
            color: "#FFD56A",
            low: 80,
            high: 89,
            border: "#AE852D",
            description: { all: "Watch" },
        },
        {
            color: "#ABE1C7",
            low: 90,
            high: 100,
            border: "#418B45",
            description: { all: "Maintain" },
        },
    ],
    _c[Tab.HoganHDS] = [
        {
            color: "rgb(from #E31C2E r g b / 10%)",
            low: -Infinity,
            high: 40,
            text: "#1a212e",
            border: "#E31C2E",
            description: getHoganDescription("No Risk", Tab.HoganHDS),
        },
        {
            color: "rgb(from #E31C2E r g b / 25%)",
            low: 40,
            high: 70,
            text: "#1a212e",
            border: "#E31C2E",
            description: getHoganDescription("Low Risk", Tab.HoganHDS),
        },
        {
            color: "rgb(from #E31C2E r g b / 50%)",
            low: 70,
            high: 90,
            text: "#1a212e",
            border: "#E31C2E",
            description: getHoganDescription("Moderate Risk", Tab.HoganHDS),
        },
        {
            color: "#E31C2E",
            low: 90,
            high: Infinity,
            text: "#ffffff",
            border: "none",
            description: getHoganDescription("High Risk", Tab.HoganHDS),
        },
    ],
    _c[Tab.HoganHPI] = [
        {
            color: "rgb(from #F3C741 r g b / 10%)",
            low: -Infinity,
            high: 26,
            text: "#1a212e",
            border: "#F3C741",
            description: getHoganDescription("Low", Tab.HoganHPI),
        },
        {
            color: "rgb(from #F3C741 r g b / 25%)",
            low: 26,
            high: 51,
            text: "#1a212e",
            border: "#F3C741",
            description: getHoganDescription("Below Average", Tab.HoganHPI),
        },
        {
            color: "rgb(from #F3C741 r g b / 50%)",
            low: 51,
            high: 76,
            text: "#1a212e",
            border: "#F3C741",
            description: getHoganDescription("Above Average", Tab.HoganHPI),
        },
        {
            color: "#F3C741",
            low: 76,
            high: Infinity,
            text: "#000000",
            border: "none",
            description: getHoganDescription("High", Tab.HoganHPI),
        },
    ],
    _c[Tab.HoganMVPI] = [
        {
            color: "rgb(from #5972A3 r g b / 10%)",
            low: -Infinity,
            high: 26,
            text: "#1a212e",
            border: "#5972A3",
            description: getHoganDescription("Low", Tab.HoganMVPI),
        },
        {
            color: "rgb(from #5972A3 r g b / 25%)",
            low: 26,
            high: 51,
            text: "#1a212e",
            border: "#5972A3",
            description: getHoganDescription("Below Average", Tab.HoganMVPI),
        },
        {
            color: "rgb(from #5972A3 r g b / 50%)",
            low: 51,
            high: 76,
            text: "#1a212e",
            border: "#5972A3",
            description: getHoganDescription("Above Average", Tab.HoganMVPI),
        },
        {
            color: "#5972A3",
            low: 76,
            high: Infinity,
            text: "#ffffff",
            border: "none",
            description: getHoganDescription("High", Tab.HoganMVPI),
        },
    ],
    _c[Tab.NoColors] = [
        {
            color: "#FFFFFF",
            low: -Infinity,
            high: Infinity,
            text: "#1A212E",
            border: "#CCD3D7",
        },
    ],
    _c[Tab.ImmersiveAgility] = [
        {
            color: "#31687F03",
            low: -Infinity,
            high: 2,
            text: "#1a212e",
            description: { Capabilities: "Very Low", Potential: "Very Low" },
            border: "#31687F",
        },
        {
            color: "#31687F1A",
            low: 2,
            high: 3,
            text: "#1a212e",
            description: { Capabilities: "Low", Potential: "Low" },
            border: "#31687F",
        },
        {
            color: "#31687F40",
            low: 3,
            high: 4,
            text: "#1a212e",
            description: { Capabilities: "Average", Potential: "Average" },
            border: "#31687F",
        },
        {
            color: "#31687F80",
            low: 4,
            high: 5,
            text: "#FFFFFF",
            description: { Capabilities: "High", Potential: "High" },
            border: "#31687F",
        },
        {
            color: "#31687F",
            low: 5,
            high: Infinity,
            text: "#ffffff",
            description: { Capabilities: "Very High", Potential: "Very High" },
            border: "#31687F",
        },
    ],
    _c[Tab.ImmersiveMeta] = [
        {
            color: "rgb(from #197E95 r g b / 1%)",
            low: -Infinity,
            high: 2,
            text: "#1a212e",
            border: "#197E95",
        },
        {
            color: "rgb(from #197E95 r g b / 10%)",
            low: 2,
            high: 3,
            text: "#1a212e",
            border: "#197E95",
        },
        {
            color: "rgb(from #197E95 r g b / 25%)",
            low: 3,
            high: 4,
            text: "#1a212e",
            border: "#197E95",
        },
        {
            color: "rgb(from #197E95 r g b / 50%)",
            low: 4,
            high: 5,
            text: "#1a212e",
            border: "#197E95",
        },
        {
            color: "#197E95",
            low: 5,
            high: Infinity,
            text: "#ffffff",
            border: "#197E95",
        },
    ],
    _c);
